// todo: remove
export default function fetchPolyfill(url, opts = {}) {
    const req = new XMLHttpRequest();

    req.open(opts.method || "GET", url);
    req.send();

    return new Promise((res, rej) => {
        req.addEventListener("load", load => {
            if (req.status === 200) {
                return res(JSON.parse(req.response));
            }

            rej(JSON.parse(req.response));
        });
        req.addEventListener("error", error => {
            rej(JSON.parse(req.response));
        });
    });
}
